module.exports = __webpack_public_path__ + "img/ywjs_01.76309a63.png";